<template>
  <FilterTypeRow
    :nr-of-elements="nrOfTactics"
    :title="title"
    :is-selected="isCurrentContextType"
    :applied-filter-text="currentContextName"
    selected-position="right"
    @on-select="selectType"
  />
</template>

<script>
import { computed } from 'vue';

import useAuthoring from '~/composables/useAuthoring';
import FilterTypeRow from '~/components/filters/FilterTypeRow.vue';

export default {
  components: { FilterTypeRow },
  props: {
    contextType: {
      type: Object,
      default: () => {},
    },
    nrOfTactics: {
      type: Number,
      default: 0,
    },
    selectedContextTypeId: {
      type: String,
      default: '',
    },
  },

  setup(props, { emit }) {
    const { tacticContextFilters } = useAuthoring();

    const isCurrentContextType = computed(() => props.contextType.id === props.selectedContextTypeId);
    const currentContextName = computed(() => tacticContextFilters.value[props.contextType.id]?.name);
    const title = computed(() => props.contextType.title);

    const selectType = () => emit('set-selected-type', props.contextType.id);

    return {
      isCurrentContextType,
      title,
      selectType,
      currentContextName,
    };
  },
};
</script>
